import api from "../../api/flexiapp";
import cordova from "../../api/cordova";

export default {
    queueTimer: null,
    checkPeriod: 2000,
    init() {
        this.scheduleTick();
    },
    addPicture(pictureData)
    {
        let queue = this.getQueue();
        queue.push(pictureData);
        this.saveQueue(queue);
    },
    saveQueue(queue)
    {
        window.localStorage.setItem('picture-queue',JSON.stringify(queue));
        this.updateStats(queue);
    },
    getQueue()
    {
        let data = window.localStorage.getItem('picture-queue');

        if (data)
            return JSON.parse(data);
        else
            return new Array(0);
    },
    updateStats(queue)
    {
        if (!queue)
            queue = this.getQueue();
        window.$vue.$store.commit('flexiapp/setPendingOfflineUploadImageCount', queue.length);
        cordova.getNetworkUpdate();
    },
    scheduleTick() {
        if (this.queueTimer)
            clearTimeout(this.queueTimer);

        this.queueTimer=setTimeout(() => {
                    this.processQueue();
                }, this.checkPeriod);
    },
    processQueue(queue)
    {
        window.$vue.$log.info('tick');

        if (!queue)
            queue = this.getQueue();
        
        if (queue.length!=0) {

        let currentPicture = queue[0];

        this.processQueueItem(currentPicture, (rsOK) => {
            if (rsOK)
            {
                queue=queue.slice(1);
                this.saveQueue(queue);
                window.$vue.$emit('picture-uploaded',currentPicture);
            }

            this.scheduleTick();
            });
        }else{
            this.scheduleTick();
        }
    },
    processQueueItem(item, callback) {
        window.$vue.$log.info('processQueueItem:'+item.workorderId+'-'+item.lineId); 
     
             api.postPicture(
                item.workorderId,
                item.lineId,
                item,
                function () {
                    callback(true);
                    window.$vue.$log.info('processQueueItem: rsOK');
                    cordova.getNetworkUpdate();
                },
                function (error) {
                    window.$vue.$log.error(error);
                    callback(false);
                }
            ); 
    },
    processNetworkUpdate(data){
        window.$store.commit('flexiapp/onNetworkEvent', data);
    },
    processAwake(){
        cordova.getNetworkUpdate();
    }

}